<template>
  <!-- BEGIN: Content-->
  <div class="app-content content">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top profile__avatar">
            <div class="col-12">
              <h2 class="content-header-title mb-0">
                {{ title }}
              </h2>
            </div>
          </div>
        </div>
        <div
          class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none"
        >
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-primary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
               
              @click="$router.push({name: 'researcher.administration.evaluator-history.create'})"
            ><i data-feather="plus" /></a>
            <!-- <a
              href="#"
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Professional background settings"
            ><i data-feather="settings" /></a> -->
          </div>
        </div>
      </div>
      <div
        v-if="pendings > 0"
        class="alert alert-danger mt-1 p-1"
      >
        There are {{ pendings }} Evaluator Histories where Department is not parameterized
      </div>
      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">
            <CompleteTable
              :sorted-field="sortedField"
              :data="data"
              :sort-mapping="sortMapping"
              :title="'evaluators'"
              :total="dataTotal"
              :fetch-path="'evaluatorHistories/fetch'"
              :filter-path="'evaluatorHistories/filter'"
            >
              <!-- :export-path="'evaluatorHistories/export'" -->
              <template v-slot="{field}">
                <td
                  class="text-end"
                >
                  <b-dropdown
                    variant="link"
                    no-caret
                    toggle-class="p-0"
                    right
                  >
                    <template #button-content>
                      <i data-feather="more-vertical" />
                    </template>
                    <div
                      class="btn-group dropup dropdown-icon-wrapper d-none d-sm-block"
                    >
                      <b-dropdown-item @click="$router.push({name: 'researcher.dashboard', params: { id: field.user.id }})">
                        <i
                          class="me-50"
                          data-feather="user"
                        /> View researcher profile
                      </b-dropdown-item>
                      <div class="dropdown-divider" />
                      <b-dropdown-item @click="$router.push({name: 'researcher.administration.evaluator-history.edit', params: { id: field.id }})">
                        <i
                          class="me-50"
                          data-feather="edit-3"
                        /> Edit
                      </b-dropdown-item>
                      <b-dropdown-item @click="showDeleteModal(field)">
                        <i
                          class="me-50"
                          data-feather="trash-2"
                        /> Delete <span class="float-end"><i data-feather="lock" /></span>
                      </b-dropdown-item>
                    </div>
                  </b-dropdown>
                  <a
                    href=""
                    class="btn btn-icon btn-light-secondary d-block d-sm-none"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasMenu"
                    aria-controls="offcanvasBottom"
                  ><i
                    data-feather="more-vertical"
                  /></a>
                </td>
              </template>
              <template #customfilters>
                <div
                  v-if="loggedUser.roles.includes('super-admin')"
                  class="mb-1"
                >
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >Researcher</label>
                  <v-select
                    label="name"
                    :options="users"
                    :get-option-key="option => option.id"
                    @search="onSearch({ name: $event }, 'users/fetchFakeUsers')"
                    @input="saveFilter($event, 'researcher')"
                  />
                  <hr>
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Host Institution</label>
                  <v-select
                    label="name"
                    :options="hosts"
                    :get-option-key="option => option.id"
                    @search="onSearch({ name: $event }, 'institutions/filter')"
                    @input="saveFilter($event, 'institution')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Department</label>
                  <v-select
                    label="name"
                    :options="departments"
                    :get-option-key="option => option.id"
                    @search="onSearch({ name: $event }, 'institutions/fetchDepartments')"
                    @input="saveFilter($event, 'department')"
                  />
                </div>
                <p><strong>Begin date</strong></p>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >From</label>
                  <date-picker
                    v-model="filters['begin_date_from']"
                    format="D MMM Y"
                    value-type="format"
                    class="w-100"
                    @change="saveFilter($event, 'begin_date_from')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >To</label>
                  <date-picker
                    v-model="filters['begin_date_to']"
                    format="D MMM Y"
                    value-type="format"
                    class="w-100"
                    @change="saveFilter($event, 'begin_date_to')"
                  />
                </div>
                <p><strong>End date</strong></p>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >From</label>
                  <date-picker
                    v-model="filters['end_date_from']"
                    format="D MMM Y"
                    value-type="format"
                    class="w-100"
                    @change="saveFilter($event, 'end_date_from')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >To</label>
                  <date-picker
                    v-model="filters['end_date_to']"
                    format="D MMM Y"
                    value-type="format"
                    class="w-100"
                    @change="saveFilter($event, 'end_date_to')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Current evaluator</label>
                  <v-select
                    label="name"
                    :clearable="false"
                    :options="evaluatorsTotal"
                    :get-option-key="option => option.id"
                    @search="onSearch($event, 'users/fetchEvaluators')"
                    @input="saveFilter($event, 'evaluator')"
                  />
                </div>
                <div class="mb-1">
                  <div class="form-check form-check-success">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      @change="saveFilter($event.target.checked ? 'true' : 'false', 'pending')"
                    >
                    <label
                      class="form-check-label"
                      for="colorCheck3"
                    >Uncompleted registers</label>
                  </div>
                </div>
                <div class="mb-1">
                  <div class="form-check form-check-success">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      @change="saveFilter($event.target.checked ? 'true' : 'false', 'present')"
                    >
                    <label
                      class="form-check-label"
                      for="colorCheck3"
                    >End date: Present</label>
                  </div>
                </div>
              </template>
            </CompleteTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import vSelect from 'vue-select'
import CompleteTable from '../../../partials/components/CompleteTable.vue'

export default {
  components: {
    CompleteTable,
    BDropdown,
    BDropdownItem,
    vSelect,
    DatePicker,
  },
  data() {
    return {
      filters: [],
      sortedField: 'Researcher',
      defaultFields: [
        {
          name: 'Researcher',
          checked: true,
          order: 1,
        },
        {
          name: 'Host Institution',
          checked: true,
          order: 2,
        },
        {
          name: 'Department',
          checked: true,
          order: 3,
        },
        {
          name: 'Interlocutor',
          checked: true,
          order: 4,
        },
        {
          name: 'Current evaluator',
          checked: true,
          order: 5,
        },
        {
          name: 'Begin date',
          checked: true,
          order: 6,
        },
        {
          name: 'End date',
          checked: true,
          order: 7,
        },
      ],
      sortMapping: {
        Researcher: 'user.name',
        'Host Institution': 'hostInstitution1.name',
        Department: 'department1_table',
        Interlocutor: 'interlocutor',
        'Current evaluator': 'evaluator.name',
        'Begin date': 'begin_date',
        'End date': 'end_date_table',
      },
      title: 'Evaluator-host histories',
    }
  },
  computed: {
    ...mapGetters({
      fields: 'modals/tableSettingsFields',
      data: 'evaluatorHistories/items',
      dataTotal: 'evaluatorHistories/itemsTotal',
      users: 'users/fakeUsers',
      loggedUser: 'auth/admin',
      hosts: 'institutions/institutions',
      departments: 'institutions/departments',
      evaluatorsTotal: 'users/evaluators',
      pendings: 'evaluatorHistories/itemsPending',
      filtersAux: 'filters/filters',
    }),
  },
  async mounted() {
    await this.$store.dispatch('modals/fetchUserFields', 'evaluator_histories')
    await this.$store.dispatch('evaluatorHistories/filter', this.filtersAux)
    await this.$store.dispatch('evaluatorHistories/fetchPending')
    if (!this.fields || this.fields.length === undefined) { // If user doesnt have default fields, load the true default
      await this.$store.dispatch('modals/fetchFields', {
        fields: this.defaultFields,
        table: 'evaluator_histories',
      })
    }
    setTimeout(() => {
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 500)
  },
  methods: {
    saveFilter(value, field) {
      this.filters[field] = value
      this.$store.dispatch('filters/saveFilters', {
        value,
        field,
      })
    },
    async onSearch(search, store) {
      search.active = true
      if (search.name !== '') {
        await this.$store.dispatch(store, search)
      }
    },
    async showDeleteModal(item) {
      if (!item.last_host_history_id) {
        await this.$store.dispatch('modals/saveDeleteData', { name: 'evaluatorHistories', url: `${Vue.prototype.$groupUrl}evaluator-histories/${item.id}` })
        this.$store.dispatch('modals/showDeleteModal', true)
      } else {
        Vue.swal({
          title: 'The Evaluator history has an associated host history!',
          html: 'Both records will be deleted',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Confirm',
        }).then(async result => {
          if (result.isConfirmed) {
            await this.$store.dispatch('modals/saveDeleteData', { name: 'evaluatorHistories', url: `${Vue.prototype.$groupUrl}/evaluator-histories/${item.id}` })
            this.$store.dispatch('modals/showDeleteModal', true)
          }
        })
      }
    },
  },
}
</script>
